(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["doorway-blocks"] && !Shopify.designMode) return;
  try {
    
  class LyleDoorwayBlocks extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-doorway-blocks-track]')
      this.list = this.querySelector('[data-doorway-blocks-list]')
      this.previous = this.querySelector('[data-doorway-blocks-previous]')
      this.next = this.querySelector('[data-doorway-blocks-next]')

      this.previous?.addEventListener('click', this.handlePrevious)
      this.next?.addEventListener('click', this.handleNext)
      this.track?.addEventListener('scroll', this.updateControls, { passive: true })

      if (this.track && 'ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(this.updateControls)
        this.resizeObserver.observe(this.track)
      }

      this.initReveal()
      requestAnimationFrame(this.updateControls)
    }

    disconnectedCallback() {
      this.previous?.removeEventListener('click', this.handlePrevious)
      this.next?.removeEventListener('click', this.handleNext)
      this.track?.removeEventListener('scroll', this.updateControls)
      this.resizeObserver?.disconnect()
      this.revealObserver?.disconnect()
    }

    handlePrevious = () => this.move(-1)

    handleNext = () => this.move(1)

    move(direction) {
      const card = this.list?.querySelector('.doorway-blocks__slide')
      if (!card || !this.track) return

      const gap = parseFloat(getComputedStyle(this.list).columnGap) || 0
      const distance = card.getBoundingClientRect().width + gap
      const behavior = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'

      this.track.scrollBy({ left: distance * direction, behavior })
    }

    updateControls = () => {
      if (!this.track) return

      const position = Math.abs(this.track.scrollLeft)
      const maximum = Math.max(0, this.track.scrollWidth - this.track.clientWidth)

      if (this.previous) this.previous.disabled = position <= 1
      if (this.next) this.next.disabled = position >= maximum - 1
    }

    initReveal() {
      if (matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
        this.classList.add('is-active')
        return
      }

      this.classList.add('is-observed')
      this.revealObserver = new IntersectionObserver(
        ([entry]) => {
          if (!entry?.isIntersecting) return

          this.classList.add('is-active')
          this.revealObserver.disconnect()
        },
        { threshold: 0.2 }
      )
      this.revealObserver.observe(this)
    }
  }

  if (!customElements.get('lyle-doorway-blocks')) {
    customElements.define('lyle-doorway-blocks', LyleDoorwayBlocks)
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-faq"] && !Shopify.designMode) return;
  try {
    
  const openGorgiasChat = () => {
    const gorgias = window.GorgiasChat;

    if (gorgias && typeof gorgias.open === 'function') {
      gorgias.open();
      return;
    }

    const ready = gorgias && typeof gorgias.init === 'function'
      ? gorgias.init()
      : new Promise((resolve) => {
          window.addEventListener('gorgias-widget-loaded', resolve, { once: true });
        });

    ready.then(() => {
      if (typeof window.GorgiasChat?.open === 'function') {
        window.GorgiasChat.open();
      }
    });
  };

  const setupFaqChat = () => {
    const faqSections = document.querySelectorAll('[data-main-faq]');

    for (const faqSection of faqSections) {
      const chatButtons = faqSection.querySelectorAll('[data-main-faq-chat]');

      for (const chatButton of chatButtons) {
        chatButton.addEventListener('click', openGorgiasChat);
      }
    }
  };

  const setupFaqNavigation = () => {
    const faqSections = document.querySelectorAll('[data-main-faq]');

    for (const faqSection of faqSections) {
      const links = Array.from(faqSection.querySelectorAll('[data-main-faq-link]'));
      const categories = Array.from(faqSection.querySelectorAll('[data-main-faq-category]'));

      if (!links.length || !categories.length) {
        continue;
      }

      const categoryIds = categories.map((category) => category.dataset.mainFaqCategory);
      const initialHash = window.location.hash.replace('#', '');
      const initialId = categoryIds.includes(initialHash) ? initialHash : categoryIds[0];

      const setActiveCategory = (id, shouldUpdateUrl = true) => {
        for (const link of links) {
          const isActive = link.dataset.mainFaqLink === id;
          link.classList.toggle('is-active', isActive);

          if (isActive) {
            link.setAttribute('aria-current', 'true');
          } else {
            link.removeAttribute('aria-current');
          }
        }

        for (const category of categories) {
          category.hidden = category.dataset.mainFaqCategory !== id;
        }

        if (shouldUpdateUrl) {
          const updatedUrl = new URL(window.location.href);
          updatedUrl.hash = id;
          history.replaceState({}, '', updatedUrl.href);
        }
      };

      setActiveCategory(initialId, false);

      for (const link of links) {
        link.addEventListener('click', (event) => {
          event.preventDefault();
          const id = link.dataset.mainFaqLink;
          const activeLink = links.find((item) => item.classList.contains('is-active'));

          setActiveCategory(id);

          if (activeLink?.dataset.mainFaqLink !== id) {
            const activeCategory = categories.find((category) => category.dataset.mainFaqCategory === id);
            const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
            activeCategory?.scrollIntoView({ behavior, block: 'start' });
          }
        });
      }
    }
  };

  setupFaqNavigation();
  setupFaqChat();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class LyleProductRecommendations extends HTMLElement {
    #controller
    #observer
    #carousel
    #resizeObserver

    connectedCallback() {
      this.#controller = new AbortController()
      this.#observer = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return
        this.#observer.disconnect()
        void this.#load(this.#controller.signal)
      }, { rootMargin: '400px 0px' })
      this.#observer.observe(this.closest('.shopify-section'))
    }

    disconnectedCallback() {
      this.#controller.abort()
      this.#observer.disconnect()
      this.#resizeObserver?.disconnect()
      this.#carousel?.destroy()
      this.#carousel = null
    }

    async #load(signal) {
      const config = JSON.parse(this.querySelector('[data-product-cards-config]').textContent)
      const recommendations = JSON.parse(this.querySelector('[data-recommendations-config]').textContent)
      const list = this.querySelector('.splide__list')
      try {
        const { fetchProductRecommendations } = await import('@lyle/algolia-recommendations')
        const hits = await fetchProductRecommendations(config.algolia, recommendations, signal)
        if (signal.aborted) return
        if (hits.length) {
          const [{ formatAlgoliaProductHit }, { AlgoliaProductCardRenderer }] = await Promise.all([
            import('@lyle/algolia-product-fetcher'),
            import('@lyle/algolia-product-card'),
          ])
          if (signal.aborted) return
          const renderer = new AlgoliaProductCardRenderer({
            config,
            icons: window.icons || {},
            isMobile: () => window.matchMedia('(width < 1024px)').matches,
          })
          list.innerHTML = hits.map((hit, index) =>
            `<li class="splide__slide">${renderer.render(formatAlgoliaProductHit(hit, config), index)}</li>`
          ).join('')
        }
      } catch (error) {
        if (signal.aborted) return
        console.warn('Product recommendations could not load.', error)
      }

      if (signal.aborted) return
      this.closest('.product-recommendations').hidden = !list.children.length
      if (!list.children.length) return
      const { default: Splide } = await import('@splidejs/splide')
      if (signal.aborted) return
      const speed = Number(this.dataset.carouselSpeed) || 0
      this.#carousel = new Splide(this.querySelector('.splide'), {
        arrows: true,
        autoplay: speed > 0 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches,
        interval: speed * 1000,
        gap: 'var(--spacing-5xs)',
        mediaQuery: 'min',
        pagination: false,
        perMove: 1,
        perPage: 2,
        rewind: true,
        i18n: {
          prev: this.querySelector('.splide__arrow--prev').getAttribute('aria-label'),
          next: this.querySelector('.splide__arrow--next').getAttribute('aria-label'),
          play: this.querySelector('.splide__toggle__play')?.textContent,
          pause: this.querySelector('.splide__toggle__pause')?.textContent,
        },
        breakpoints: { 768: { perPage: 4 } },
      })
      const updateControls = () => {
        const image = this.querySelector('.product-card__image-frame')
        if (image) this.style.setProperty('--recommendations-arrow-top', `${image.offsetHeight / 2}px`)
        this.querySelector('.splide__arrow--prev').disabled = this.#carousel.index === 0
        this.querySelector('.splide__arrow--next').disabled = this.#carousel.index >= this.#carousel.Components.Controller.getEnd()
      }
      this.#carousel.on('mounted arrows:updated resized', updateControls)
      this.#carousel.mount()
      this.#resizeObserver = new ResizeObserver(updateControls)
      this.#resizeObserver.observe(this)
      await customElements.whenDefined('lyle-product-cards')
      if (!signal.aborted) await this.closest('lyle-product-cards').hydrate(list)
    }
  }

  if (!customElements.get('lyle-product-recommendations')) {
    customElements.define('lyle-product-recommendations', LyleProductRecommendations)
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["secondary-header-settings"] && !Shopify.designMode) return;
  try {
    
  class LyleSecondaryHeader extends HTMLElement {
    connectedCallback() {
      const header = document.querySelector('lyle-site-header');

      if (!header) {
        this.hidden = true;
        return;
      }

      if (!this.closest('lyle-site-header')) {
        header.append(this);
        return;
      }

      if (this.dataset.initialized) return;

      this.dataset.initialized = 'true';
      this.abortController = new AbortController();
      this.nav = this.querySelector('.secondary-header__nav');
      this.links = [...this.querySelectorAll('[data-section-reference]')];
      this.sections = this.links
        .map((link) => document.getElementById(link.dataset.sectionReference))
        .filter(Boolean);

      this.links.forEach((link) => {
        link.addEventListener('click', this.handleClick, {
          signal: this.abortController.signal,
        });
      });

      this.observer = new IntersectionObserver(this.handleIntersection, {
        rootMargin: '-49% 0px -49%',
      });
      this.sections.forEach((section) => this.observer.observe(section));
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.observer?.disconnect();
      delete this.dataset.initialized;
    }

    handleClick = (event) => {
      const section = document.getElementById(event.currentTarget.dataset.sectionReference);
      const header = this.closest('lyle-site-header');

      if (!section || !header) return;

      event.preventDefault();
      const top = section.getBoundingClientRect().top + window.scrollY - (header.offsetHeight * 2);
      window.scrollTo({ top, behavior: 'smooth' });
    };

    handleIntersection = (entries) => {
      const activeSection = entries.find((entry) => entry.isIntersecting)?.target;

      if (!activeSection) return;

      this.links.forEach((link) => {
        const isActive = link.dataset.sectionReference === activeSection.id;
        link.classList.toggle('is-active', isActive);
        if (isActive) {
          link.setAttribute('aria-current', 'true');
        } else {
          link.removeAttribute('aria-current');
        }

        if (isActive && this.nav.scrollWidth > this.nav.clientWidth) {
          this.nav.scrollTo({ left: link.offsetLeft, behavior: 'smooth' });
        }
      });
    };
  }

  if (!customElements.get('lyle-secondary-header')) {
    customElements.define('lyle-secondary-header', LyleSecondaryHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["styleguide"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-styleguide]').forEach((root) => {
    const toHex = (color) => {
      const parts = color.match(/\d+(\.\d+)?/g);
      if (!parts || parts.length < 3) return color;
      const hex = parts
        .slice(0, 3)
        .map((part) => Number(part).toString(16).padStart(2, '0'))
        .join('');
      return `#${hex.toUpperCase()}`;
    };

    const update = () => {
      root.querySelectorAll('[data-swatch]').forEach((swatch) => {
        const chip = swatch.querySelector('[data-swatch-chip]');
        const value = swatch.querySelector('[data-swatch-value]');
        value.textContent = toHex(getComputedStyle(chip).backgroundColor);
      });

      root.querySelectorAll('[data-type-row]').forEach((row) => {
        const sample = row.querySelector('[data-type-sample]');
        const size = row.querySelector('[data-type-size]');
        const styles = getComputedStyle(sample);
        size.textContent = `${parseFloat(styles.fontSize)}px / ${styles.fontWeight}`;
      });

      root.querySelectorAll('[data-spacing-item]').forEach((item) => {
        const bar = item.querySelector('[data-spacing-bar]');
        const value = item.querySelector('[data-spacing-value]');
        value.textContent = `${parseFloat(getComputedStyle(bar).width)}px`;
      });
    };

    update();
    window.addEventListener('resize', update);
  });

  } catch(e) { console.error(e); }
})();
})();
